<template>
  <div class="max-w-7xl mx-auto"
    :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ReadingPen',
  metaInfo () {
    return {
      title: '點讀館'
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
